export const mapOrderBookItemFromApi = (
  resp: ApiOrderBookItem
): OrderBookItem => {
  return {
    count: resp.count,
    price: resp.price,
  };
};

const mapOrderBookFromApi = (resp: ApiOrderBook): OrderBook => {
  return {
    sell: resp.sell.map(mapOrderBookItemFromApi),
    buy: resp.buy.map(mapOrderBookItemFromApi),
  };
};

export default mapOrderBookFromApi;
